import { render } from "./Moodboard2.vue?vue&type=template&id=f6de93ce&scoped=true"
import script from "./Moodboard2.vue?vue&type=script&lang=js"
export * from "./Moodboard2.vue?vue&type=script&lang=js"

import "./Moodboard2.vue?vue&type=style&index=0&id=f6de93ce&scoped=true&lang=scss"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6de93ce"]])

export default __exports__